import { DefaultValidator } from '../'
import { translateValidator } from '../../i18next/i18nextHelpers'
import { withDefaultValidator } from '../formValidators.utils'

const defaultTranslateKey = 'validator.onlyNumber'

export const onlyNumber = value => !isNaN(value)

export const onlyNumberTranslated: DefaultValidator = withDefaultValidator(
  (localeKey?: string) =>
    translateValidator(onlyNumber, localeKey || defaultTranslateKey),
)
